import { hideNotification } from '@cian/favorites-assign-widget';
import { v4 as uuid } from 'uuid';

import { TThunkAction } from '../../types/redux';
import { deleteFromFavorite as deleteFromFavoriteService } from '../../services/favorites';
import { finishFavoriteUpdate, rollbackFavoriteUpdate, startFavoriteUpdate } from '../../actions/recommendations';
import { trackDeleteFromFavorite } from './tracking';
import { TFavoriteActionParameters } from './types';

export function deleteFromFavorite(parameters: TFavoriteActionParameters): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    const { recommendation } = parameters;
    const requestId = uuid();

    dispatch(hideNotification());
    dispatch(startFavoriteUpdate({ offerId: recommendation.offerId, isFavorite: false, requestId }));

    try {
      await deleteFromFavoriteService(context, {
        dealType: recommendation.dealType,
        offerId: recommendation.offerId,
        offerType: recommendation.offerType,
      });
    } catch (error) {
      dispatch(rollbackFavoriteUpdate({ offerId: recommendation.offerId, isFavorite: true, requestId }));

      throw error;
    }

    try {
      trackDeleteFromFavorite(parameters);
    } finally {
      dispatch(finishFavoriteUpdate({ offerId: recommendation.offerId, requestId }));
    }
  };
}
